import { Pagination } from 'antd';

export function CustomPagination({ pagination, onChange }) {
  return (
    <Pagination
      className="cp_1"
      current={pagination?.current ? pagination?.current : 0}
      total={pagination?.total ? pagination?.total : 0}
      pageSize={pagination?.pageSize ? pagination?.pageSize : 0}
      onChange={onChange}
      showTotal={(total, range) => {
        if (total === '0') {
          return ' ';
        }
        return `${range[0]}-${range[1]} of ${total} items`;
      }}
    />
  );
}
